import { render, staticRenderFns } from "./HomeWorks.vue?vue&type=template&id=b742b264"
import script from "./HomeWorks.vue?vue&type=script&lang=js"
export * from "./HomeWorks.vue?vue&type=script&lang=js"
import style0 from "./HomeWorks.vue?vue&type=style&index=0&id=b742b264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports